import React from 'react';
import { Paper, Typography, useTheme } from '@material-ui/core';
import { alpha } from '@material-ui/core/styles';

interface InfoBoxProps {
  title: string | React.ReactNode;
  children: React.ReactNode;
  style?: React.CSSProperties;
}

export const InfoBox: React.FC<InfoBoxProps> = ({ title, children, style }) => {
  const theme = useTheme();
  return (
    <Paper
      elevation={3}
      style={{
        padding: '12px',
        background: alpha(theme.palette.secondary.main, 0.05),
        color: theme.palette.secondary.main,
        borderRadius: '8px',
        fontSize: '0.875rem',
        border: `1px solid ${theme.palette.secondary.main}`,
        lineHeight: '1.3',
        ...style,
      }}
    >
      <Typography 
        variant="body2" 
        component="div"
        style={{ 
          margin: '0 0 8px 0', 
          fontWeight: 'bold',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: '8px',
          flexWrap: 'wrap',
        }}
      >
        {title}
      </Typography>
      {children}
    </Paper>
  );
};